import OpenAsset from '../../../controls/asset/OpenAsset';

const OpenAssetSection = () => {
  return <OpenAsset />;
};

export default OpenAssetSection;
